import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import Raven from 'raven-js';
import { QueryRouter } from 'sarsaparilla';

import App from './App';
import store from './store';
import './index.scss';

Raven.config(process.env.SENTRY_CONFIG_URL, process.env.SENTRY_CONFIG).install();

render(
  <div id="developer-portal" className="dev-portal-content">
    <Provider store={store}>
      <QueryRouter shouldRestoreScroll>
        <App />
      </QueryRouter>
    </Provider>
  </div>,
  document.getElementById('recApp')
);
